import React from 'react';
import PropTypes from 'prop-types';
import MainGridMiddleRightRowDayOffTypeSlot from './MainGridMiddleRightRowDayOffTypeSlot';

/**
 * MainGridMiddleRightDayOffTypeSlot
 */
class MainGridMiddleRightDayOffTypeSlot extends React.Component {

  render() {
    const actions = this.props.actions;
    let MainGridNodes = this.props.dataDayOff.map((maingrid, index) => {
      let cnt = index + 1;
      maingrid['cnt'] = cnt;
      return (
        <MainGridMiddleRightRowDayOffTypeSlot dataDayOffItem={maingrid} actions={actions} key={index} />
      );
    });

    return (
      <div className="ledger_sheet_scroll return_x return_y ib bar bar_xy" style={{ width: 'auto', height: '100%' }} onScroll={e => this.props.actions.onScroll(e.target)}>
        <div className="ledger_sheet_scroll_inner scroll_x max_height_target max_height_day row_width_dayoff">
          <div className="modlue center_col ib textright grid_line_bottom">
            {MainGridNodes}
          </div>
        </div>
      </div>
    );
  }
}

MainGridMiddleRightDayOffTypeSlot.propTypes = {
  dataDayOff: PropTypes.any.isRequired,
  actions: PropTypes.any.isRequired,
};

export default MainGridMiddleRightDayOffTypeSlot;
